<template>
  <div class="question-container" style="position: relative">
        <span class="icon" v-bind:class="{'icon-arrow-down': minimizeData, 'icon-arrow-up': !minimizeData}"
              style="cursor: pointer;position: absolute;right: 15px;z-index: 2"
              @click="minimizeData = !minimizeData"></span>
    <span v-if="!disabled && !hideDelete" class="icon icon-delete" style="position:absolute;cursor: pointer;right: 35px;z-index: 2"
          @click="deleteClicked"></span>
    <vue-slide-up-down :active="!this.minimizeData" :duration="500">
      <div v-if="!this.minimizeData" style="position: relative">
        <div class="content-row">
          <div
              style="display: flex;flex-direction: column;justify-content: center;align-items: center;padding-right: 8px">
            <label for="multiple-choice">Multiple Choice</label>
            <input :disabled="disabled" type="checkbox" id="multiple-choice" v-model="localValue.multiple_choice">
            <label for="sozio">Soziofrage</label>
            <input :disabled="disabled || disableSocialQuestion" type="checkbox" id="sozio" v-model="localValue.social_question">
          </div>
          <div style="width: 60%;position: relative">
                        <textarea class="my-textarea" v-model="localValue.text"
                                  placeholder="Hier die Frage editieren" :maxlength="maxQuestionLength"
                                  @input="updateValue()">
                        </textarea>
            <label v-if="typeof localValue.text !== 'undefined'" class="max-question-length-label">
              {{ localValue.text.length }}/{{ maxQuestionLength }} Zeichen
            </label>
          </div>
        </div>
        <div class="answer-container">
          <template v-for="(answer, index) of localValue.answers">
            <div v-bind:key="index" class="answer-input">
              <input style="width: 100%;font-size: 12px" :disabled="disabled" v-model="answer.text"
                     type="text" :maxlength="maxAnswerLength"
                     @input="updateValue()">
              <label v-if="typeof answer.text !== 'undefined'" class="max-answer-label">
                {{ answer.text.length }}/{{ maxAnswerLength }}
              </label>
              <span v-if="localValue.multiple_choice && index === localValue.answers.length - 1" class="icon icon-info"
                    style="position:absolute; right: -15px" v-tooltip="'Die letzte Antwort einer multiple Choice Frage hat die semantische Funktion: Keine der genannten.'"></span>
              <span v-if="!disabled" class="icon icon-delete" style="cursor: pointer"
                    @click="deleteAnswerClicked(index)"></span>
            </div>
          </template>
        </div>
        <div v-if="!disabled" style="display: flex;justify-content: center">
          <AdaButton style="width: 250px" title="Antwort hinzufügen" @click="addAnswer" type="createButton"
                     icon="icon-add"></AdaButton>
        </div>
      </div>
    </vue-slide-up-down>
    <div v-if="this.minimizeData" style="display: flex;align-items: center">
      <img v-if="localValue.multiple_choice" src="../assets/images/multiple_choice.png">
      <img v-if="!localValue.multiple_choice" src="../assets/images/single_choice.png">
      <label style="padding-left: 20px" v-html="textBoldBrand"></label>
    </div>
  </div>
</template>

<script>

import AdaButton from "./AdaButton";

export default {
  name: "QuestionBuilder",
  components: {
    AdaButton
  },
  props: {
    value: {
      required: true,
      type: Object
    },
    minimize: {
      required: false,
      type: Boolean,
      default: false
    },
    disabled: {
      required: false,
      default: false
    },
    hideDelete: {
      required: false,
      default: false
    },
    brand: {
      required: true,
      default: ''
    },
    disableSocialQuestion: {
      required: true,
      default: false
    }
  },
  computed: {
    textBoldBrand() {
      return this.localValue.text.replace('[' + this.brand + ']', '<b>' + this.brand + '</b>');
    }
  },
  data: function () {
    return {
      minimizeData: false,
      maxQuestionLength: 200,
      maxAnswerLength: 25,
      maxAnswers: 5,
      localValue: JSON.parse(JSON.stringify(this.value)),
      skipEmit: false
    }
  },
  mounted() {
    this.minimizeData = this.minimize;
  },
  watch: {
    value: {
      deep: true,
      handler(newVal) {
        this.skipEmit = true;
        this.localValue = JSON.parse(JSON.stringify(newVal));
        this.$nextTick(() => { this.skipEmit = false; });
      }
    },
    localValue: {
      deep: true,
      handler() {
        if (this.skipEmit) return;
        this.$emit('input', JSON.parse(JSON.stringify(this.localValue)));
      }
    }
  },
  methods: {
    addAnswer() {
      if (this.localValue.answers.length >= this.maxAnswers) {
        this.$noty.error(`Maximal ${this.maxAnswers} Antwortmöglichkeiten`);
        return;
      }
      if (!this.disabled) {
        this.localValue.answers.push({text: ''});
        this.updateValue();
      }
    },
    updateValue() {
      this.$emit('input', JSON.parse(JSON.stringify(this.localValue)));
    },
    deleteClicked() {
      if (!this.disabled) {
        this.$emit('delete');
      }
    },
    deleteAnswerClicked(index) {
      this.localValue.answers.splice(index, 1);
    }
  }
}
</script>

<style scoped>

img {
  width: 18px;
  height: 100%;
}

textarea {
  resize: none;
}

.question-container {
  width: 100%;
  background-color: #dfe2e6;
  padding: 16px
}

.content-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.my-textarea {
  height: 100px;
  width: 100%;
  position: relative;
}

.answer-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 16px;
}

.answer-container > input {
  width: 45%;
  margin-bottom: 8px;
}

.max-question-length-label {
  position: absolute;
  font-size: 10px;
  bottom: 5px;
  right: 10px;
}

.answer-input {
  position: relative;
  width: 48%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.max-answer-label {
  position: absolute;
  right: 17px;
  font-size: 10px;
  top: 4px;
}

</style>